import { render, staticRenderFns } from "./MineOrder.vue?vue&type=template&id=38b0166a"
import script from "./MineOrder.vue?vue&type=script&lang=js"
export * from "./MineOrder.vue?vue&type=script&lang=js"
import style0 from "./MineOrder.vue?vue&type=style&index=0&id=38b0166a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports